<template lang="html">
  <div @click="$emit('click')" class="floating-button">
    <span class="floating-button-filter-text">FILTRAR{{ filtersNum ? ` (${filtersNum})` : '' }}</span>
  </div>
</template>

<script>
import store from '@/store'

export default {
  computed: {
    distanceFilter: () => store.state.search.distance !== -1 ? 1 : 0,

    simpleFilters: () => store.state.filters.simples || [],

    filtersNum () { return this.simpleFilters.filter(f => f.key !== 'q').length + this.distanceFilter }
  }
}
</script>

<style lang="scss">
  @import '../../scss/breakpoints';
  @import '../../scss/colors';

  @media screen and (max-width: map-get($grid-breakpoints, "md")) {
    .floating-button {
      width: fit-content;
      height: 4rem;
      border-radius: 2rem;
      background-color: $primary;
      color: white;
      font-weight: bold;
      text-align: center;
      position: fixed;
      z-index: 1;
      bottom: 1rem;
      right: 1rem;
      cursor: pointer;

      &-filter-text {
        line-height: 4rem;
        margin: 0 0.25rem;
      }

      & * {
        height: 100%;
        background-size: contain;
      }
    }

    .filter-icon {
      display: inline-block;
    }

    .filters-active {
      position: absolute;
      background-color: #FF1818;
      border-radius: 100%;
      width: 1rem;
      height: 1rem;
      color: white;
      font-weight: bold;
      line-height: 180%;
      top: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/FloatingButton.vue